import { makeAutoObservable } from 'mobx'
import { type ITabItem } from 'shared/ui'
import { UserAccessRequestType } from 'entities/Users'
import { type IResponseMembersCountsRequests } from 'entities/Users/api/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { tableLimitStore } from 'entities/TableLimit'
import { AccessRequestsStore } from './accessRequestsStore'

export type RequestsTabKey = 'salesmsg-access' | 'inbox-access' | 'permissions-update'

export class RequestsMembersStore {
  private _salesmsgAccessStore: AccessRequestsStore
  private _inboxAccessStore: AccessRequestsStore
  private _permissionsUpdateStore: AccessRequestsStore
  private _salesmsgAccessCount = 0
  private _inboxAccessCount = 0
  private _permissionsAccessCount = 0

  constructor(entities: IEntitiesStore) {
    makeAutoObservable(this)
    this._salesmsgAccessStore = new AccessRequestsStore(
      UserAccessRequestType.SalesmsgAccess,
      'salesmsgAccessRequestsTable',
      entities,
      () => tableLimitStore.getLimit('salesmsg-access-requests-table'),
      (value) => tableLimitStore.setLimit('salesmsg-access-requests-table', value),
      'salesmsg-access-requests-table'
    )
    this._inboxAccessStore = new AccessRequestsStore(
      UserAccessRequestType.InboxAccess,
      'inboxAccessRequestsTable',
      entities,
      () => tableLimitStore.getLimit('inbox-access-requests-table'),
      (value) => tableLimitStore.setLimit('inbox-access-requests-table', value),
      'inbox-access-requests-table'
    )
    this._permissionsUpdateStore = new AccessRequestsStore(
      UserAccessRequestType.PermissionsUpdate,
      'permissionsUpdateRequestsTable',
      entities,
      () => tableLimitStore.getLimit('permissions-update-requests-table'),
      (value) => tableLimitStore.setLimit('permissions-update-requests-table', value),
      'permissions-update-requests-table'
    )
  }

  updateCounts = (counts: IResponseMembersCountsRequests) => {
    this._salesmsgAccessCount = counts.salesmsg_access
    this._inboxAccessCount = counts.inbox_access
    this._permissionsAccessCount = counts.permissions_access
  }

  get tabs(): ITabItem<RequestsTabKey>[] {
    return [
      {
        name: 'Salesmsg access',
        key: 'salesmsg-access',
        count: this._salesmsgAccessCount,
      },
      {
        name: 'Inbox access',
        key: 'inbox-access',
        count: this._inboxAccessCount,
      },
      {
        name: 'Permissions update',
        key: 'permissions-update',
        count: this._permissionsAccessCount,
      },
    ]
  }

  get salesmsgAccessStore() {
    return this._salesmsgAccessStore
  }

  get inboxAccessStore() {
    return this._inboxAccessStore
  }

  get permissionsUpdateStore() {
    return this._permissionsUpdateStore
  }

  dispose = () => {
    this._salesmsgAccessStore.dispose()
    this._inboxAccessStore.dispose()
    this._permissionsUpdateStore.dispose()
  }
}
